import { useState } from "react";
import { useTranslation } from "react-i18next";
// @mui material components
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDStepper from "components/MDStepper";

// Authentication layout components
import AuthLayout from "layouts/authentication/components/AuthLayout";
// Authentication forms components
import BasicInfoForm from "layouts/authentication/components/AuthForms/BasicInfoForm";
// Images & icon
import { ArrowBack } from "@mui/icons-material";
import OTPForm from "../components/AuthForms/OTPForm";
import CompleteInfoForm from "../components/AuthForms/CompleteInfoForm";
import RulesForm from "../components/AuthForms/RulesForm";
import MDButton from "components/MDButton";

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";
//icons
import bgImage from "assets/images/bg-pattern.svg";
import logo from "assets/images/logos/logo.png";
import { ReactComponent as BackOutlined } from "assets/images/icons/back.svg";
import MDCard from "components/MDCard";

function SignUp() {
  const [step, setStep] = useState(0);
  const { background } = colors;
  const { t } = useTranslation();
  const steps = ["اطلاعات اولیه", "تایید شماره همراه", "تکمیل اطلاعات", "قوانین و مقررات"];
  const renderForms = (step) => {
    switch (step) {
      case 0:
        return (
          <BasicInfoForm
            onNext={(e) => {
              setStep(e);
            }}
          />
        );
      case 1:
        return <OTPForm />;
      case 2:
        return <CompleteInfoForm />;
      case 3:
        return <RulesForm />;
      default:
        break;
    }
  };
  return (
    <AuthLayout image={bgImage}>
      <MDCard
        sx={({ breakpoints }) => ({
          backgroundColor: background.pale,
          borderRadius: "48px !important",
          height: "86vh",
          ml: 5,
          [breakpoints.up("xxxl")]: {
            width: "35vw",
          },
          [breakpoints.up("xl")]: {
            width: "43vw",
          },
          [breakpoints.down("xl")]: {
            width: "auto",
            height: "95vh",
            ml: 2,
            mr: 3,
          },
        })}
      >
        <MDBox
          sx={({ breakpoints }) => ({
            [breakpoints.down("xl")]: {
              px: 0,
            },
          })}
          pt={2}
          pb={3}
          px={3}
        >
          <MDBox display="flex" justifyContent="flex-start" ml={-2} mb={-6}>
            <MDButton
              color="text"
              variant="text"
              startIcon={<BackOutlined />}
              onClick={() => {
                step !== 0 && setStep(step - 1);
              }}
            >
              {t("buttons.back")}
            </MDButton>
          </MDBox>
          <MDBox display="flex" justifyContent="center" mb={2}>
            <MDAvatar
              src={logo}
              sx={({ breakpoints }) => ({
                width: pxToRem(150),
                height: pxToRem(150),

                [breakpoints.down("xl")]: {
                  width: pxToRem(113),
                  height: pxToRem(113),
                },
              })}
            />
          </MDBox>
          <MDStepper steps={steps} activeStep={step} onClick={setStep} />
          <MDBox
            sx={({ breakpoints }) => ({
              mt: 3,
              mx: 6,

              [breakpoints.down("xl")]: {
                mx: 1,
                mt: 1.5,
              },
            })}
          >
            {renderForms(step)}
          </MDBox>

          <MDBox display="flex" alignItems="center" mt={2}>
            <MDBox
              display="flex"
              sx={({ breakpoints }) => ({
                position: "absolute",
                bottom: 30,
                right: "28%",
                [breakpoints.down("xl")]: {
                  position: "absolute",
                  bottom: 20,
                  right: "5vw",
                },
              })}
            >
              <MDButton
                fullWidth
                sx={({ breakpoints }) => ({
                  width: pxToRem(314),
                  height: pxToRem(54),
                  [breakpoints.down("xl")]: {
                    width: "78vw",
                  },
                })}
                color="primary"
                onClick={() => {
                  step !== 3 && setStep(step + 1);
                }}
              >
                {t("buttons.saveAndContinue")}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDCard>
    </AuthLayout>
  );
}

export default SignUp;
